var map = {
	"./ERatingOverFour.png": 2880,
	"./ERatingOverThree.png": 66070,
	"./PublishXChallenge.png": 1319,
	"./PublishXExercise.png": 3363,
	"./RatingOverFour.png": 39372,
	"./RatingOverThree.png": 18169,
	"./SolvingXExerciseInTotal.png": 93951,
	"./SolvingXExerciseInYLanguage.png": 82585,
	"./TakenXBronzeTrophies.png": 13696,
	"./TakenXGoldTrophies.png": 57573,
	"./TakenXSilverTrophies.png": 23404,
	"./XPeopleCopiedYourChallenge.png": 77274,
	"./XPeopleCopiedYourExercise.png": 88838,
	"./XPeopleTakenChallenge.png": 49982,
	"./XPeopleTakenExercise.png": 9639,
	"./default.png": 68960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30617;